import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { OsIconNames, OsIconsService } from './os-icon.service';
import { TablerIconName } from './tabler-icons.type';

@Component({
  selector: 'am-icon',
  template: `
    <mat-icon
      data-testid="os-icon"
      *ngIf="osIcon"
      [attr.size]="size"
      [svgIcon]="osIcon"
      [class.os-icon--full-color]="color === 'os-brand'"
    ></mat-icon>
  `,
  styleUrls: ['./am-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmIconComponent implements OnInit, OnChanges {
  constructor(public osIcons: OsIconsService) {}
  @Input() name: TablerIconName | OsIconNames | string = '';
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  @Input() color:
    | 'primary'
    | 'accent'
    | 'success'
    | 'caution'
    | 'warn'
    | 'os-brand';
  osIcon: string;

  @HostBinding('attr.role') role = 'img';

  @HostBinding('class')
  get className(): string {
    return [
      `ti ti-${this.name}`,
      this.size ? `size-${this.size}` : null,
      this.osIcon ? 'os-icon' : null,
      this.color ? `fg-${this.color}` : null,
    ]
      .filter((x) => x)
      .join(' ');
  }

  ngOnInit() {
    this.osIcon = this.osIcons.getIcon(this.name, this.color === 'os-brand');
  }

  ngOnChanges(changes: SimpleChanges) {
    this.osIcon = this.osIcons.getIcon(this.name, this.color === 'os-brand');
  }
}
